import { render, staticRenderFns } from "./RoleLibDetail.vue?vue&type=template&id=074e754e&scoped=true"
import script from "./RoleLibDetail.vue?vue&type=script&lang=js"
export * from "./RoleLibDetail.vue?vue&type=script&lang=js"
import style0 from "./RoleLibDetail.vue?vue&type=style&index=0&id=074e754e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074e754e",
  null
  
)

export default component.exports